import { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import compose from "recompose/compose";

import {
  crudGetOne,
  crudGetList,
  translate,
  RestMethods,
  FETCH_START,
  FETCH_END,
  SAVING_START,
  SAVING_END,
  showNotification
} from "jazasoft";

import { dataProvider } from "../../../App";
import handleError from "../../../utils/handleError";

export class CuChecklistItemController extends Component {
  componentDidMount() {
    this.fetchCuChecklist();
    this.fetchData("products");
    this.fetchData("fabric-patterns");
    this.fetchData("fabric-categories");
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.id !== nextProps.id || nextProps.version !== this.props.version) {
      this.fetchCuChecklist(nextProps.id);
    }
  }

  fetchCuChecklist = (id = this.props.id) => {
    if (id) {
      this.props.dispatch(crudGetOne("cuChecklists", id, this.props.basePath, this.props.requestConfig));
    }
  };

  fetchData = resource => {
    if (!resource) return;
    this.props.dispatch(crudGetList(resource, { page: 0, pageSize: 100 }));
  };

  updateEstimation = (record, cb) => {
    const options = {
      url: `estimations/${record.id}`,
      method: "put",
      data: { ...record },
      params: { action: "merchant" }
    };
    this.props.dispatch({ type: FETCH_START });
    this.props.dispatch({ type: SAVING_START });
    dataProvider(RestMethods.CUSTOM, undefined, options)
      .then(response => {
        cb && cb(response.data);
        this.props.dispatch({ type: FETCH_END });
        this.props.dispatch({ type: SAVING_END });
      })
      .catch(err => {
        handleError(err, this.props.dispatch);
        this.props.dispatch({ type: FETCH_END });
        this.props.dispatch({ type: SAVING_END });
      });
  };

  updateCuChecklistItem = (checklistItem = {}, cb) => {
    const options = {
      url: `cuChecklists/${this.props.id}/cuChecklistItems/${checklistItem.id}`,
      method: "put",
      data: checklistItem
    };
    this.props.dispatch({ type: FETCH_START });
    this.props.dispatch({ type: SAVING_START });
    dataProvider(RestMethods.CUSTOM, undefined, options)
      .then(response => {
        if (response.status === 200) {
          this.props.dispatch(showNotification(`Cu Checklist updated successfully.`));
          this.fetchCuChecklist();
          cb && cb(response.data);
        }
        this.props.dispatch({ type: FETCH_END });
        this.props.dispatch({ type: SAVING_END });
      })
      .catch(err => {
        handleError(err, this.props.dispatch);
        this.props.dispatch({ type: FETCH_END });
        this.props.dispatch({ type: SAVING_END });
      });
  };

  render() {
    const {
      id,
      itemId,
      isLoading,
      saving,
      record: cuChecklist,
      products,
      fabricPatterns,
      fabricCategories,
      children,
      dispatch,
      version,
      translate,
      history
    } = this.props;

    if (!children) return null;

    const record = cuChecklist && cuChecklist.checkListItems.find(e => `${e.id}` === itemId);

    return children({
      id,
      itemId,
      isLoading,
      saving,
      cuChecklist,
      record,
      products,
      fabricPatterns,
      fabricCategories,
      updateCuChecklistItem: this.updateCuChecklistItem,
      updateEstimation: this.updateEstimation,
      translate,
      version,
      dispatch,
      history
    });
  }
}

CuChecklistItemController.propTypes = {
  //props provided by user
  className: PropTypes.string,
  classes: PropTypes.object,
  children: PropTypes.func.isRequired,
  requestConfig: PropTypes.object,
  //props from state
  record: PropTypes.object,
  isLoading: PropTypes.bool,
  translate: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => {
  const resourceState = state.jazasoft.resources["cuChecklists"];
  const id = props.match.params.id;
  const itemId = props.match.params.itemId;

  const dataProducts = state.jazasoft.resources["products"] && state.jazasoft.resources["products"].data;
  const dataFabricTypes = state.jazasoft.resources["fabric-patterns"] && state.jazasoft.resources["fabric-patterns"].data;
  const datafabricCategories = state.jazasoft.resources["fabric-categories"] && state.jazasoft.resources["fabric-categories"].data;

  const products = dataProducts ? Object.keys(dataProducts).map(id => dataProducts[id]) : [];
  const fabricPatterns = dataFabricTypes ? Object.keys(dataFabricTypes).map(id => dataFabricTypes[id]) : [];
  const fabricCategories = datafabricCategories
    ? Object.keys(datafabricCategories).map(id => datafabricCategories[id])
    : [];
  return {
    id,
    itemId,
    record: resourceState && resourceState.data[id],
    isLoading: state.jazasoft.loading > 0,
    saving: state.jazasoft.saving,
    version: state.jazasoft.ui.viewVersion,
    products,
    fabricPatterns,
    fabricCategories
  };
};

export default compose(
  translate,
  connect(mapStateToProps)
)(CuChecklistItemController);
